import {ErrorPriority} from "../../enums/ErrorPriority";
import {BaseError} from "./BaseError";
import {NavigationVisitor} from "../navigation/NavigationVisitor";
import {Tenant} from "../tenant/Tenant";
import {TenantApplication} from "../tenant/TenantApplication";
import {ErrorLog} from "./ErrorLog";

export class ErrorMessage extends BaseError {
    private static GENERAL_DESCRIPTION_KEY = "error.name.generalErrorMessage";
    private static INFO_DESCRIPTION_KEY = "error.name.infoErrorMessage";

    data: string;

    constructor(id: string, tenant: Tenant, application: TenantApplication, mostRecentOccurred: Date | string, occurrenceCount: number,
                errorPriority: ErrorPriority, isSolved: boolean, data: string, errorlogs?: ErrorLog[], solution?: string) {
        super(id, tenant, application, mostRecentOccurred, occurrenceCount, errorPriority, isSolved, errorlogs, solution);
        this.data = data;
    }

    public override accept(visitor: NavigationVisitor, openNewTab: boolean = false): void {
        visitor.visitErrorMessage(this, openNewTab);
    }

    public override get descriptionKey(): string {
        return this.errorPriority == 'information' ? ErrorMessage.INFO_DESCRIPTION_KEY : ErrorMessage.GENERAL_DESCRIPTION_KEY;
    }

    protected override getContentForSummary(): string {
        return this.data;
    }
}
